<template>
  <div @click.stop="click">
    <RadioGroup
      v-model="model"
      class="formily-radio"
      :options="options"
      :position="position"
      :horizontal="horizontal"
      :hollow-style="hollowStyle"
    >
    </RadioGroup>
  </div>
</template>

<script>
/* eslint-disable vue/require-default-prop, vue/require-prop-types */
import { RadioGroup } from '@didi/rich-ui'
export default {
  components: { RadioGroup },
  props: {
    options: {},
    position: {
      default: 'right',
    },
    horizontal: {},
    hollowStyle: {},
    value: {},
  },
  computed: {
    model: {
      get() {
        return this.value
      },
      set(newVal) {
        this.$emit('input', newVal)
        this.$emit('change', newVal)
      },
    },
  },
  methods: {
    click() {
      setTimeout(() => {
        this.$emit('click', this.model)
      })
    },
  },
}
</script>

<style lang="scss" scoped></style>
